import React, { useEffect, useState } from "react";
import axiosInstance from "./interceptor/intercetptor-inctence";

const baseURL = process.env.REACT_APP_IMAGE;

// Reuse same loader
const SvgLoader = ({ className = "", style = {} }) => (
  <div className={className} style={style}>
    <div className="d-flex justify-content-center align-items-center" style={{ height: "100%" }}>
      <svg width="35" height="35" viewBox="0 0 100 100">
        <circle
          cx="50"
          cy="50"
          fill="none"
          stroke="var(--theme-default)"
          strokeWidth="8"
          r="35"
          strokeDasharray="164.93 56.97"
        >
          <animateTransform
            attributeName="transform"
            type="rotate"
            dur="1s"
            repeatCount="indefinite"
            values="0 50 50;360 50 50"
          />
        </circle>
      </svg>
    </div>
  </div>
);

const S3PdfViewer = ({
  fileName,
  fallbackText = "Unable to load PDF",
  height = "500px",
  className = "w-100",
  showOpenButton = true,
}) => {
  const [pdfUrl, setPdfUrl] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const loadPdf = async () => {
      if (!fileName) {
        setError(true);
        setLoading(false);
        return;
      }

      // Local uploads
      if (fileName.startsWith("/uploads/")) {
        setPdfUrl(baseURL + fileName);
        setLoading(false);
        return;
      }

      try {
        const res = await axiosInstance.post("/api/report/preSigned-url", {
          key: fileName,
        });
        setPdfUrl(res.data.data.presignedURL);
      } catch (err) {
        console.error("PDF presigned URL error:", err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    loadPdf();
  }, [fileName]);

  if (loading) return <SvgLoader className={className} style={{ height }} />;

  if (error || !pdfUrl) {
    return <div className="text-danger text-center">{fallbackText}</div>;
  }

  return (
    <div className={className}>
      {/* {showOpenButton && (
        <div className="mb-2 text-end">
          <a
            href={pdfUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-sm btn-primary"
          >
            Open PDF
          </a>
        </div>
      )} */}

      <iframe
        src={pdfUrl}
        title="PDF Viewer"
        width="100%"
        height={height}
        style={{ border: "1px solid #ddd", borderRadius: "6px" }}
      />
    </div>
  );
};

export default S3PdfViewer;
